module.exports = __webpack_public_path__ + "img/秒杀预告背景.0edebc75.png";